<script setup lang="ts">
import type { TStandardImageKeys } from 'assets/data/branding-library';
import GenericError from '~/components/user-interface/generic-error.vue';
import GenericLoader from '~/components/user-interface/generic-loader.vue';
import { useWinnersData } from '~/composables/useStates/useWinnersData';
import type { TWinnersCategory } from '~/interfaces/winners/winnersInterfaces';
defineProps<{ tab: TWinnersCategory }>();
const { $t } = useNuxtApp();
const { winnersLoading } = useWinnersData();
</script>
<template>
  <div class="w-full bg-layer rounded-xl pl-3 p-2">
    <WinnersSectionHeader
      :title="tab.key"
      :alt="$t(tab.key)"
      :icon-name="tab.icon as TStandardImageKeys"
    />
    <div v-if="!winnersLoading">
      <WinnersCategoryList
        v-if="!!tab.data && tab.data?.length > 0"
        :games="tab.data.slice(0, 10)"
        :category="$t(tab.key)"
      />
      <GenericError v-else :scroll-to-view="false">
        {{ $t(`${tab.key}-list-empty`) }}
      </GenericError>
    </div>
    <GenericLoader v-else standalone />
  </div>
</template>
